import { render, staticRenderFns } from "./TeacherAssessments.vue?vue&type=template&id=6ae0b56c"
import script from "./TeacherAssessments.vue?vue&type=script&lang=js"
export * from "./TeacherAssessments.vue?vue&type=script&lang=js"
import style0 from "./TeacherAssessments.vue?vue&type=style&index=0&id=6ae0b56c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports